import Swal from 'sweetalert2';
import authService from '../src/services/authService';

const moment = require('moment');
const momentTz = require('moment-timezone');

export const showSuccessMessage = (message, callBack = null) => {
  Swal.fire({
    customClass: {
      container: 'swal-container',
    },
    icon: 'success',
    title: 'Sucesso!',
    text: message,
    showConfirmButton: true,
    confirmButtonColor: '#2c387e'
  }).then(() => {
    if (callBack) {
      callBack();
    }
  });
};

export const showConfirmMessage = async (title, text) => {
  return await Swal.fire({
    customClass: {
      container: 'swal-container',
    },
    title: title,
    text: text,
    icon: 'warning',
    showCancelButton: true,
    confirmButtonText: 'Sim',
    cancelButtonText: 'Não',
    reverseButtons: false,
  });
};

export const showErrorMessage = (message) => {
  Swal.fire({
    customClass: {
      container: 'swal-container',
    },
    icon: 'error',
    title: 'Oops...',
    text: message,
  });
};

export const shouldDisplayField = (fieldName, readonly, additionalFields) => {
  if (!readonly) {
    return true;
  }
  return additionalFields.length === 0 || additionalFields.includes(fieldName);
};

export const tratarCatch = (message, tela, error, navigate) => {
  if (error.response) {
    if (error.response.status === 400 && error.response.data?.message) {
      showErrorMessage(error.response.data.message);
    } else if (error.response.status === 400 && error.response.data?.error) {
        showErrorMessage(error.response.data.error);
    } else if (error.response.status === 400) {  
      showErrorMessage(message);
    } else if (error.response.status === 401) {
      if (tela === 'Login') {
        showErrorMessage(message);
      } else if (error.response.data?.message) {
        showErrorMessage(message);
        navigate('/');
      }
      else {
        showErrorMessage('Sem autorização para fazer essa chamada!');
        authService.logout(navigate);
      }
    } else if (error.response.status === 404 && error.response.data?.message) {
      showErrorMessage(error.response.data.message);
    } else if (error.response.status === 404) {
      showErrorMessage(`${tela} não encontrado(a)`);
    } else if (error.response.status === 500 && error.response.data?.error.message) {
      showErrorMessage(`Erro no servidor (${error.response.data?.error.message})`);
    } else if (error.response.status === 500 && error.response.data?.message) {
      showErrorMessage(`Erro no servidor (${error.response.data.message})`);
    } else if (error.response.status === 500) {
      showErrorMessage(`Erro no servidor, tente novamente mais tarde`);
    } else if (error.response.data?.message) {
      showErrorMessage(`${error.response.data.message} (status: ${error.response.status})`);
    } else {
      showErrorMessage(`Ocorreu um erro desconhecido (status: ${error.response.status})`);
    }
  } else if (error.data?.error?.message) {
    showErrorMessage(`${error.data?.error?.message} (status: ${error?.status})`);
  } else if ((error.message) && (error.code)) {
    showErrorMessage(`${error.message} (code: ${error.code})`);
  } else if (error.message) {
    showErrorMessage(`${error.message}`);
  } else {
    showErrorMessage(tela + ' - Ocorreu um erro desconhecido - Msg: ' + JSON.stringify(error));
  }
};

export const formatReal = (value) => {
  const formattedValue = new Intl.NumberFormat('pt-BR', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
    useGrouping: true,
  }).format(value);

  return formattedValue.replace('R$', '').trim();
}

export const validateRequiredFields = (fields, requiredFields) => {
  const errors = {};

  requiredFields.forEach((field) => {
    if (fields[field] === undefined || fields[field] === null || fields[field] === '') {
      errors[field] = 'Campo obrigatório';
      //errors[field] = `Campo ${field} é obrigatório`;
    }
  });

  const isValid = Object.keys(errors).length === 0;

  return { errors, isValid };
};

export const updateFields = (source, dataFields) => {
  const updated = { ...dataFields };

  if (source.created_at) {
    updated.created_at = source.created_at;
  }

  if (source.updated_at) {
    updated.updated_at = source.updated_at;
  }

  Object.keys(dataFields).forEach((key) => {
    if (source.hasOwnProperty(key)) {
      updated[key] = source[key];
    }
  });

  return updated;
};

export const isAdmin = () => {
  const admin = localStorage.getItem("admin");
  return ((admin) && (admin === "true")) ? true : false;
};

export const myUser = () => {
  return localStorage.getItem("username") || "";
};

export const formatCpfCnpj = (value) => {
  const length = value.toString().length;
  
  if (length === 11) {
    // Formata o CPF: 999.999.999-99
    return value.toString().replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, '$1.$2.$3-$4');
  } else if (length === 14) {
    // Formata o CNPJ: 99.999.999/9999-99
    return value.toString().replace(/(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/, '$1.$2.$3/$4-$5');
  } else {
    // Retorna o valor original
    return value.toString();
  }
}

export const formatDate = (
  dateTime,
  includeTime = false,
  useUTC = false,
  formatString = 'DD/MM/YYYY'
) => {
  // Se includeTime for verdadeiro, adicione 'HH:mm' ao formato
  if (includeTime) {
    formatString += ' HH:mm';
  }

  if (useUTC) {
    return convertUTCtoLocal(dateTime, formatString);
  } else {
    const formattedDateTime = moment(dateTime).format(formatString);
    return formattedDateTime;
  }
};

// Modifique a função convertUTCtoLocal para aceitar o formatString
export const convertUTCtoLocal = (utcDateTime, formatString = 'DD/MM/YYYY') => {
  const userTimeZone = momentTz.tz.guess();
  const localDateTime = moment.utc(utcDateTime).tz(userTimeZone);
  const formattedLocalDateTime = localDateTime.format(formatString);
  return formattedLocalDateTime;
};

export const daysUntilDate = (inputDate) => {
  const currentDate = moment();
  const targetDate = moment(inputDate);

  if (targetDate.isSame(currentDate, 'day')) {
    return 'Hoje';
  } else if (targetDate.isBefore(currentDate, 'day')) {
    return 'Vencida';
  } else {
    const daysRemaining = targetDate.diff(currentDate, 'days');
    return daysRemaining;
  }
};

export const getChipSettings = (dataFinal) => {
  const daysUntilDateResult = daysUntilDate(dataFinal);
  const formattedDate = formatDate(dataFinal, false, true);
  if (daysUntilDateResult === 'Hoje') {
    return { color: 'purple', label: 'Hoje' };
  } else if (daysUntilDateResult === 'Vencida') {
    return { color: 'red', label: `Vencida (${formattedDate})` };
  } else {
    return { color: 'green', label: `${formattedDate} (${daysUntilDateResult}D)` };
  }
};